/**
 * @file GeneratedContentWrapper.tsx
 * @description A wrapper component for generated content.
 * Provides consistent styling and layout for both viewing and editing modes.
 * Includes optional toolbar rendering.
 */

import React, { ReactNode } from "react";
import { Link } from "react-router-dom";

import ContentIcon from "../../components/common/icons/ContentIcon";

interface GeneratedContentWrapperProps {
  children: ReactNode;
  toolbar?: ReactNode;
}

const GeneratedContentWrapper: React.FC<GeneratedContentWrapperProps> = ({
  children,
  toolbar,
}) => {
  return (
    <div
      id="generated-content-wrapper"
      className="w-full transition-all sm:w-2/3"
    >
      <div
        className="p-6 shadow-lg bg-base-100 rounded-bl-[60px] rounded-tr-[60px] xl:p-12
      
          [&_p]:mb-[1em]

          [&_a]:link-primary

          [&_ol]:list-decimal
          [&_ol]:mb-[1em]
          [&_ol]:pl-4
          
          [&_ul]:list-disc
          [&_ul]:mb-[1em]
          [&_ul]:pl-4

          [&_h1]:mb-[1em]
          [&_h1]:text-neutral
          [&_h1]:!text-4xl
          [&_h1]:font-semibold

          [&_h2]:mb-[1em]
          [&_h2]:text-neutral
          [&_h2]:!text-4xl
          [&_h2]:font-semibold

          [&_h3]:mb-[1em]
          [&_h3]:text-neutral
          [&_h3]:!text-3xl
          [&_h3]:font-semibold

          [&_h4]:mb-[1em]
          [&_h4]:text-neutral
          [&_h4]:!text-2xl
          [&_h4]:font-semibold

          [&_h5]:mb-[1em]
          [&_h5]:text-neutral
          [&_h5]:!text-xl
          [&_h5]:font-semibold            

          [&_h6]:mb-[1em]
          [&_h6]:text-neutral
          [&_h6]:!text-lg
          [&_h6]:font-semibold            

          [&_table]:mb-[1em]
          [&_thead]:border-b
          [&_tbody]:divide-y
          [&_th]:text-left
          [&_th]:p-2
          [&_tr]:divide-x
          [&_td]:p-2
      "
      >
        {toolbar && (
          <div role="toolbar" className="flex justify-end gap-3 mb-10">
            {toolbar}
          </div>
        )}
        {toolbar && <div className="mb-10 divider"></div>}
        {children}
        <div className="mt-10 mb-6 divider"></div>
        <div className="flex flex-col items-center mx-auto text-center xl:w-2/3">
          <ContentIcon className="w-32 mb-2" />
          <p className="mt-4 !mb-10 text-3xl font-medium text-primary">
            Il contenuto è stato salvato nel tuo archivio personale
          </p>
          <Link
            to="/archivio-contenuti"
            className="px-6 font-normal text-lg border-none rounded-full !text-primary-content btn btn-primary"
          >
            Vai all'archivio contenuti
          </Link>
        </div>
      </div>
    </div>
  );
};

export default GeneratedContentWrapper;
